import React from 'react';
import { Check } from 'lucide-react';
import { useLang, tx } from '../i18n/LanguageContext';
import { COURSE_COLOR_PRESETS } from '../lib/courses';

/**
 * Color picker for courses. Lets admin pick from preset names or any hex value.
 * value: string (preset key OR "#xxxxxx")
 * onChange: (newValue: string) => void
 */
const ColorPicker = ({ value, onChange, testId = 'color-picker' }) => {
  const { lang } = useLang();
  const L = (ar, en) => tx(lang, ar, en);
  const isHex = typeof value === 'string' && value.startsWith('#');
  const hexValue = isHex ? value : '#3b82f6';

  return (
    <div className="space-y-2" data-testid={testId}>
      <div className="flex flex-wrap gap-2">
        {Object.entries(COURSE_COLOR_PRESETS).map(([key, theme]) => {
          const selected = value === key;
          return (
            <button
              key={key}
              type="button"
              onClick={() => onChange(key)}
              data-testid={`color-preset-${key}`}
              title={key}
              aria-pressed={selected}
              className={`w-8 h-8 rounded-lg border-2 flex items-center justify-center transition-transform hover:scale-110 ${selected ? 'border-white scale-110 shadow-lg ring-2 ring-slate-900' : 'border-slate-200'}`}
              style={{ backgroundColor: theme.accent }}
            >{selected && <Check className="w-4 h-4 text-white" strokeWidth={3} />}</button>
          );
        })}
      </div>
      <div className="flex items-center gap-2 pt-1">
        <span className="text-slate-500 text-xs">{L('أو لون مخصص', 'Or custom')}:</span>
        <input
          type="color"
          value={hexValue}
          onChange={(e) => onChange(e.target.value)}
          data-testid="color-custom-hex"
          className="w-9 h-9 rounded-lg cursor-pointer bg-transparent border border-slate-200"
        />
        <span className="text-xs text-slate-500 font-mono uppercase" dir="ltr">
          {isHex ? value : ''}
        </span>
      </div>
    </div>
  );
};

export default ColorPicker;
